import { Service } from "typedi";
import { PublicStudentRulesDTO } from "../../../../../schools-backend/src/rule/application/stores/StudentRulesDTO";
import { PublicStudentRules } from "../../../../../schools-backend/src/rule/application/stores/StudentRules";

type Listener = (rules: PublicStudentRulesDTO | null) => void;

/**
 * Single source of truth for `PublicStudentRulesDTO` inside the controller.
 * Leader fills it from the server; followers receive updates over
 * BroadcastChannel. Consumers subscribe to `onChange` to re-evaluate tabs.
 *
 * Exposes both the raw DTO (for forwarding to other instances) and a hydrated
 * `PublicStudentRules` (with pre-built stores) for sync evaluation.
 */
@Service()
export class StudentRulesCache {
    private rules: PublicStudentRulesDTO | null = null;
    private hydrated: PublicStudentRules | null = null;
    private readonly listeners = new Set<Listener>();

    get(): PublicStudentRulesDTO | null {
        return this.rules;
    }

    getHydrated(): PublicStudentRules | null {
        return this.hydrated;
    }

    set(rules: PublicStudentRulesDTO | null): void {
        this.rules = rules;
        this.hydrated = rules ? new PublicStudentRules(rules) : null;
        this.listeners.forEach((l) => {
            try { l(rules); } catch (err) { console.error("[student-rules-cache] listener error", err); }
        });
    }

    onChange(listener: Listener): () => void {
        this.listeners.add(listener);
        return () => this.listeners.delete(listener);
    }
}
